export const MSP_BRAND_DRUVA = "Druva";
export const MSP_BRAND_DELL = "Dell";
